var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPanel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.429,
    height: 19.129,
    viewBox: "0 0 22.429 19.129",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27097",
    "data-name": "Group 27097",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27040",
    "data-name": "Group 27040",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27039",
    "data-name": "Group 27039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10632",
    "data-name": "Path 10632",
    d: "M252.681,320.642a3.121,3.121,0,0,1,.078-1.714,3.211,3.211,0,0,1,1.66-1.86,3.028,3.028,0,0,1,1.887-.273.259.259,0,0,0,.3-.261v-7.156a1.052,1.052,0,0,0-1.053-1.053H241.342a1.053,1.053,0,0,0-1.053,1.053v7.145a.26.26,0,0,0,.3.259,3.053,3.053,0,0,1,2.225.542,3.1,3.1,0,0,1,1.319,3.317.26.26,0,0,0,.256.315h.684a.263.263,0,0,0,.253-.206,3.172,3.172,0,0,1,6.165,0,.263.263,0,0,0,.253.206h.684A.259.259,0,0,0,252.681,320.642Zm-1.711-5.864-3.181,1.948a.778.778,0,0,1-1.184-.663v-3.9a.778.778,0,0,1,1.184-.663l3.181,1.949A.778.778,0,0,1,250.97,314.778Zm-9.932,7.27a2.123,2.123,0,1,0-2.124-2.123A2.124,2.124,0,0,0,241.038,322.048Zm12.612-2.123a2.124,2.124,0,1,0,2.124-2.123A2.124,2.124,0,0,0,253.65,319.924Zm4.239,3.194h-4.23a1.725,1.725,0,0,0-1.45.792.272.272,0,0,0,.059.362,2.781,2.781,0,0,1,.933,1.4.264.264,0,0,0,.253.2h5.642a.526.526,0,0,0,.526-.526v-.5A1.731,1.731,0,0,0,257.888,323.119Zm-14.736,0h-4.23a1.731,1.731,0,0,0-1.731,1.731v.5a.526.526,0,0,0,.526.526h5.642a.264.264,0,0,0,.253-.2,2.781,2.781,0,0,1,.933-1.4.271.271,0,0,0,.059-.362A1.725,1.725,0,0,0,243.153,323.119Z",
    transform: "translate(-237.191 -308.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10633",
    "data-name": "Path 10633",
    d: "M255.038,333.577a2.123,2.123,0,1,0-2.124-2.123A2.124,2.124,0,0,0,255.038,333.577Zm2.115,1.071h-4.23a1.731,1.731,0,0,0-1.731,1.731v.5a.526.526,0,0,0,.526.526h6.641a.526.526,0,0,0,.526-.526v-.5A1.731,1.731,0,0,0,257.153,334.648Z",
    transform: "translate(-243.823 -318.276)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanel);
export default __webpack_public_path__ + "static/media/panel.b5ac0c015c01bc9075a5ad9da035d3f8.svg";
export { ForwardRef as ReactComponent };